import { render, staticRenderFns } from "./CreateTaxInvoice.vue?vue&type=template&id=403eb2b6"
import script from "./CreateTaxInvoice.vue?vue&type=script&lang=js"
export * from "./CreateTaxInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports